





























































































import {Component, Vue, Watch, Prop} from 'vue-property-decorator';
import {Splitpanes, Pane} from 'splitpanes';
import 'splitpanes/dist/splitpanes.css';
import Breadcrumbs from '@c/controls/Breadcrumbs.vue';
import Loading from '@c/controls/Loading.vue';
import {Can} from '@casl/vue';
import {HardwareData} from '@/system/hardware/interfaces';
import HardwareDialog from './HardwareDialog.vue';
import axios from 'axios';
import HardwareView from './HardwareView.vue';
import hardwareModule from '@/store/modules/entities/hardwareModule';
import DeleteDialog from '@c/DeleteDialog.vue';
import {httpClient} from '@/api/baseApi';
import pmoduleModule from '@/store/modules/entities/pmodules/pmoduleModule';
import {PModuleType} from '@/enums/configs';
import {connectionGetActiveDevices} from '@/api/configApi';
import dtcpServerStoreModule from '@/store/modules/entities/pmodules/dtcp/dtcpServerStoreModule';
import {PModuleMAC} from '@/views/system/modules/interfaces';
import HardwaresViewHelp from './HardwaresViewHelp.vue';

@Component({
  components: {
    Splitpanes,
    Pane,
    HardwareView,
    Breadcrumbs,
    Loading,
    Can,
    HardwareDialog,
    DeleteDialog,
    HardwaresViewHelp,
  },
})
export default class HardwaresView extends Vue {
  loadingTree = false;
  errorTree = false;
  loadingSvg = false;

  showScheme = true;

  redraw = false;

  isEdit = false;

  search = '';

  typeSearch = null;

  types: any[] = [];

  amListCash: any[] = [];

  get items() {
    return [...hardwareModule.all];
  }

  get hardwareDialog() {
    return this.$refs.hardwareDialog as any;
  }

  @Prop({required: false})
  hardwareId?: string;

  selectedHardwareId: number | null = null;

  async created() {
    this.loadHardwaresList();
    if (this.hardwareId) {
      this.selectedHardwareId = parseInt(this.hardwareId);
      this.showScheme = true;
    }

    // получаем все модули и находим dtcp-сервер
    await pmoduleModule.fetchAll();
    const dtcpServers = pmoduleModule.all.filter(x => x.type === PModuleType.DtcpServerModule);
    if (dtcpServers.length) {
      // если есть dtcp-сервера, берем один из них
      const dtcpServer = dtcpServers[0];

      if (dtcpServer.guid) {
        //подключаемся к веб сокету
        this.socket = connectionGetActiveDevices(dtcpServer.guid);
        this.socket.onopen = () => {
          //отправляем action
          if (dtcpServer.id) {
            dtcpServerStoreModule.processGetActiveDevicesAction({id: dtcpServer.id});
          }
        };
        this.socket.onmessage = (e: any) => this.subscribeConectionWS(e);
      }
    }
  }

  macs: PModuleMAC[] = [];

  socket!: WebSocket | null;

  hardwareTypes: any[] = [];

  selectedHardwareMac = '';

  typedPmoduleStoreModule!: any;

  @Watch('search')
  onSearch(newVal: string) {
    if (!this.amListCash.length)
      hardwareModule.all.forEach(x => {
        this.amListCash.push(x);
      });

    this.filtering(newVal, this.typeSearch);
  }

  @Watch('typeSearch')
  onTypeSearch(newVal: string) {
    if (!this.amListCash.length)
      hardwareModule.all.forEach(x => {
        this.amListCash.push(x);
      });

    this.filtering(this.search, newVal);
  }
  filtering(name: string, type: any) {
    const moduleStoreModule = this.amListCash;

    let newList = [];

    if (name == null || name == '') newList = moduleStoreModule;
    if (name != null && name != '')
      newList = moduleStoreModule.filter(
        (x: any) =>
          x.mac.toLowerCase().includes(name.toLowerCase()) ||
          x.name.toLowerCase().includes(name.toLowerCase()),
      );
    if (type != null) newList = newList.filter((x: any) => x.type_id == type);

    this.items.length = 0;
    newList.forEach(pm => {
      this.items.push(pm);
    });
  }

  subscribeConectionWS(e: {data: string}) {
    const strParse = JSON.parse(e.data);
    this.macs = strParse.data.devices.map((x: any) => ({
      device: x.mac,
      description: `${x.mac} - ${x.type} (${x.fw_ver})`,
    }));
  }

  beforeDestroy() {
    this.closeWS();
  }

  closeWS() {
    if (this.socket) {
      this.socket.close();
      this.socket = null;
    }
  }

  addHardware() {
    this.isEdit = false;
    const request = {
      data: {
        name: '',
        mac: '',
        description: '',
        type_id: 1,
      },
    };
    this.openDialog(request);
  }

  async deleteHardware(id: any) {
    await hardwareModule.delete(id);
    await hardwareModule.fetchAll();
    this.selectedHardwareId = null;
    this.$router.push({name: `hardwares`}).catch(() => {
      return 0;
    });
  }

  async editHardware(id: any) {
    const {data} = await hardwareModule.edit(id);
    this.selectedHardwareMac = data.mac;
    this.isEdit = true;
    this.openDialog({data});
  }

  async loadHardwaresList() {
    const {data} = await httpClient.get(`hardware/types`);
    this.hardwareTypes = data.map((obj: any) => {
      return {
        id: parseInt(obj.id),
        name: obj.name,
        type: obj.type,
      };
    });
  }

  scrollToHardware(id: string) {
    const element = document.getElementById(id);
    if (element) element.scrollIntoView();
  }

  getBackground(item: any) {
    if (this.selectedHardwareId == item.id) return '#d7e1e9';
    const macsCount = this.items.filter(x => x.mac == item.mac).length;
    if (macsCount >= 2) return '#FFEB7F';
    if (this.macs.length == 0) return '';
    if (this.macs.map(mac => mac.device).includes(item.mac)) return '#76FEC5';
    else return '#FF756B';
  }

  hardwareType(typeId: number) {
    let hardwareType = [];
    hardwareType = this.hardwareTypes.filter(x => x.id == typeId);
    return hardwareType[0]?.name;
  }

  openDialog(request: any) {
    const dialog = this.$refs.hardwareDialog as any;
    const options = {
      saveCallback: (data: any) => {
        dialog.$refs.form.reset();
        dialog.close();
        this.addHardwareCallback(data, {
          dialog,
        });
      },
    };

    //TODO: CancelToken и axios должен быть в store
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    dialog.openAsync(request, source, options);
  }

  async addHardwareCallback(
    payload: HardwareData,
    options: {
      dialog: any;
    },
  ) {
    try {
      await hardwareModule.save(payload);
      await this.loadHardwareList();
      (this.$refs.hardwareView as any).updateData();
    } catch (e) {
      //TODO надо пилить нормальный обработчик ошибок
      if (e?.response.status === 400) {
        options.dialog.setupErrors(e.response.data.detail);
      } else if (e?.response.status === 422) {
        options.dialog.setupErrors(this.handleValidationErrors(e.response.data.detail));
      } else options.dialog.setupErrors({error: 'Произошла ошибка'});
    }
  }

  handleValidationErrors(detail: any[]) {
    return detail.reduce((obj, err) => {
      const key = err.loc[0] === 'body' ? err.loc[1] : err.loc[0];
      obj[`${key}ValidationError`] = err.msg;
      return obj;
    }, {});
  }

  @Watch('selectedHardwareId')
  chooseHardware(id: number | null) {
    this.selectedHardwareId = id;
    if (this.selectedHardwareId)
      this.$router
        .push({
          name: `HardwareView`,
          params: {
            hardwareId: this.selectedHardwareId.toString(),
          },
        })
        .catch(() => {
          return 0;
        });
    this.showScheme = true;
  }

  async updateHardware() {
    await hardwareModule.fetchAll();
    const hardwareId = this.selectedHardwareId ? this.selectedHardwareId : null;
    if (hardwareId) {
      this.chooseHardware(hardwareId);
      this.showScheme = true;
    }
  }

  async mounted() {
    await this.loadHardwareList();
    if (this.hardwareId) this.scrollToHardware(this.hardwareId);
  }

  // Загрузка дерева
  async loadHardwareList() {
    try {
      this.loadingTree = true;
      await hardwareModule.fetchAll();
    } catch {
      this.errorTree = true;
    } finally {
      this.loadingTree = false;
    }
  }

  get deleteDialog() {
    return this.$refs.deleteDialog as any;
  }

  deleteItem(itemID: number, itemName: string) {
    this.deleteDialog.open(
      {itemID, itemName},
      {
        deleteCallback: async () => {
          try {
            this.deleteHardware(itemID);
            this.deleteDialog.close();
            // если удаляем АМ, на котором установлен фокус, закрываем панель справа
            if (this.selectedHardwareId == itemID) {
              this.showScheme = false;
              this.$router.push({name: `hardwares`});
            }
          } catch (e) {
            this.deleteDialog.error('Произошла ошибка');
          }
        },
      },
    );
  }
}
